function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PubSub from 'pubsub-js';
import account, { accountUrl } from '../data/account';
import { DOCS } from '../data/docs-links';
import publishEvent from '../functions/publish-event';
import query from '../functions/query';
import { SearchFilter, MultiSearchFilter } from '../components/search-filter';
import RouteHelper from '../functions/route-helper';
import SearchBar from '../search/search-bar';
import GlobalPeriodControl from '../components/global-period-control';
import { getBillingSources } from '../functions/billing-status';
import { getShop } from '../functions/plan-gate';
import NotificationPanel from '../components/notification-panel';
import { onUnread } from '../functions/inbox';
import BellIcon from '../components/bell-icon';
export default class AppToolbar extends React.Component {
  constructor(props) {
    super(props);
    // The bell (CONTENT_HUB_REVIEW_DESK §7): unread badge + the panel. The page lives at /Notifications.
    _defineProperty(this, "onNotificationsClick", event => {
      this.setState({
        inboxOpen: !this.state.inboxOpen
      });
    });
    // Phone-width search: the magnifier expands an overlay row across the
    // toolbar (CSS gates .m-open to ≤767px, so this is a no-op on desktop).
    _defineProperty(this, "openMobileSearch", () => {
      this.setState({
        mobileSearch: true
      });
      setTimeout(() => {
        const el = document.querySelector('.dashboard-search-container input');
        if (el) el.focus();
      }, 50);
    });
    _defineProperty(this, "closeMobileSearch", () => this.setState({
      mobileSearch: false
    }));
    _defineProperty(this, "events", event => {});
    _defineProperty(this, "onSearchFilterSelected", e => {
      var item = e.detail.item;
      var value = item.dataset.value;
      this.setState({
        searchFilterSelection: value
      });
    });
    _defineProperty(this, "onMultiSearchFilterSelected", e => {
      var item = e.detail.item;
      var data = item.dataset;
      var value = data.value;
      var id = data.id;
      var text = data.text;
      if (id === 'search') {
        this.search.value = '';
        this.setState({
          search: text,
          multiSearchFilterSelection: data.defaultSelection,
          multiSearchFilterSelectionText: data.defaultText,
          multiType: value
        });
      } else {
        this.setState({
          multiSearchFilterSelection: value,
          multiSearchFilterSelectionText: text
        });
      }
    });
    this.state = {
      search: null,
      searchFilterSelection: null,
      multiSearchFilterSelection: null,
      multiSearchFilterSelectionText: null,
      isMulti: false,
      multiType: null,
      profileOpen: false,
      managePlanHref: null,
      mobileSearch: false
    };
  }
  componentDidMount() {
    this.events();
    this._offUnread = onUnread(n => {
      if (n !== this.state.unread) this.setState({
        unread: n,
        ring: n > (this.state.unread || 0) && this._seenUnread ? Date.now() : this.state.ring
      });
      this._seenUnread = true;
    }); // a new arrival swings the bell once
    // §222: compact ⌘K search — the shortcut focuses the federated
    // search input (results overlay unchanged).
    this._onKey = e => {
      if ((e.metaKey || e.ctrlKey) && String(e.key).toLowerCase() === 'k') {
        e.preventDefault();
        const el = document.querySelector('.dashboard-search-container input');
        if (el) el.focus();
      }
      if (e.key === 'Escape' && this.state.profileOpen) this.setState({
        profileOpen: false
      });
    };
    window.addEventListener('keydown', this._onKey);
    // Managed Pricing link for Shopify-billed workspaces: merchants change plans on
    // Shopify's own page (App Store requirement 1.2.3). Shown in the profile menu.
    (async () => {
      try {
        const sources = await getBillingSources();
        const shop = getShop();
        if (shop && Array.isArray(sources) && sources.indexOf('shopify') !== -1) {
          const store = String(shop).replace(/\.myshopify\.com$/i, '');
          this.setState({
            managePlanHref: `https://admin.shopify.com/store/${encodeURIComponent(store)}/charges/plunk-commerce/pricing_plans`
          });
        }
      } catch (e) {/* billing unknown: no link, fail quiet */}
    })();
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this._onKey);
    if (this._offUnread) this._offUnread();
  }
  get searchFilterSelection() {
    var selection = this.state.searchFilterSelection;
    var isDropdown = this.isSearchDropdown;
    if (isDropdown && selection) {
      return selection;
    } else if (isDropdown) {
      return 'Source';
    } else {
      return '';
    }
  }
  get isSearchDropdown() {
    return this.state.search === 'Activity';
  }
  get isMultiSearchDropdown() {
    return this.state.isMulti;
  }
  get searchText() {
    var search = this.state.search;
    if (!search) search = '';
    if (this.isSearchDropdown) {
      return 'Search Utm Activity';
    } else if (this.isMultiSearchDropdown) {
      return 'Search ' + search;
    } else {
      return 'Search ' + search;
    }
  }
  fireSearch(route) {
    PubSub.publish('allow-update', {});
    setTimeout(() => {
      this.props.history.push(route);
    }, 100);
  }
  render() {
    var isAuthenticated = this.props.authenticated;
    var showDropdown = this.isSearchDropdown;
    var showMultiDropdown = this.isMultiSearchDropdown;
    var searchFilterSelection = this.searchFilterSelection;
    var placeholder = this.searchText;
    const acct = account.get() || {};
    const email = account.getEmail && account.getEmail();
    const initials = String(email || '?').slice(0, 2).toUpperCase();
    const isOwner = (acct.groups || []).some(g => ['owner', 'administrator', 'root'].indexOf(String(g).toLowerCase()) !== -1);
    const studioUrl = window.location.hostname === 'staging.plunk.io' ? 'https://studio.staging.plunk.io' : 'https://studio.plunk.io';
    // ≤1024px the sidebar (which carries the wordmark) is hidden, so the
    // toolbar shows its own brand: the P mark cropped from the official
    // wordmark (same path, tight viewBox), or the white-label company name.
    // CSS hides .tb-brand at desktop widths.
    const whiteLabel = !!(acct.whiteLabel && acct.company);
    const brand = whiteLabel ? /*#__PURE__*/React.createElement("span", {
      className: "tb-brand-name"
    }, String(acct.company).toUpperCase()) : /*#__PURE__*/React.createElement("svg", {
      viewBox: "0 0 215 274",
      preserveAspectRatio: "xMinYMid meet",
      role: "img",
      "aria-label": "Plunk"
    }, /*#__PURE__*/React.createElement("g", {
      transform: "translate(6.2,267.250786) scale(0.1,-0.1)",
      fill: "#141413",
      stroke: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10 1315 l0 -1285 185 0 185 0 0 390 0 390 393 0 c424 0 506 7 671 55 328 95 544 309 618 610 31 127 31 333 0 460 -87 353 -372 587 -794 649 -87 13 -209 16 -682 16 l-576 0 0 -1285z m1180 950 c276 -42 448 -175 505 -391 21 -79 21 -259 0 -338 -59 -223 -246 -361 -535 -396 -46 -5 -241 -10 -432 -10 l-348 0 0 575 0 575 358 0 c261 0 383 -4 452 -15z"
    })));
    return /*#__PURE__*/React.createElement("app-toolbar", {
      fixed: "true",
      class: "dashboard"
    }, /*#__PURE__*/React.createElement("div", {
      className: "toggle-container"
    }, /*#__PURE__*/React.createElement("div", {
      id: "drawerToggle",
      "data-toggle": true
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-toggle"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "menu"), /*#__PURE__*/React.createElement("paper-ripple", {
      class: "circle",
      recenters: true
    }))), /*#__PURE__*/React.createElement("div", {
      className: "tb-brand"
    }, brand)), /*#__PURE__*/React.createElement("div", {
      className: "dashboard-search-container" + (this.state.mobileSearch ? " m-open" : "")
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons large-icon grey-icon",
      onClick: this.openMobileSearch
    }, "search"), /*#__PURE__*/React.createElement(SearchBar, null), /*#__PURE__*/React.createElement("span", {
      className: "tb-kbd",
      "aria-hidden": "true"
    }, "\u2318K"), this.state.mobileSearch && /*#__PURE__*/React.createElement("i", {
      className: "material-icons tb-search-close",
      onClick: this.closeMobileSearch
    }, "close")), /*#__PURE__*/React.createElement("div", {
      className: "actions-container"
    }, /*#__PURE__*/React.createElement(GlobalPeriodControl, {
      history: this.props.history
    }), /*#__PURE__*/React.createElement("div", {
      className: "nc-bell-wrap"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "notification-icon nc-bell" + (this.state.inboxOpen ? " on" : ""),
      id: "notification-icon",
      title: "Notifications",
      "aria-label": this.state.unread ? `Notifications, ${this.state.unread} unread` : "Notifications",
      "aria-expanded": !!this.state.inboxOpen,
      onClick: this.onNotificationsClick
    }, /*#__PURE__*/React.createElement("span", {
      key: this.state.ring || 0,
      className: "nc-bell-ic" + (this.state.ring ? " ring" : "")
    }, /*#__PURE__*/React.createElement(BellIcon, {
      size: 24,
      dot: !!this.state.unread
    })), this.state.unread > 0 && /*#__PURE__*/React.createElement("span", {
      className: "nc-badge"
    }, this.state.unread > 99 ? "99+" : this.state.unread)), this.state.inboxOpen && /*#__PURE__*/React.createElement(NotificationPanel, {
      history: this.props.history,
      unread: this.state.unread,
      onClose: () => this.setState({
        inboxOpen: false
      })
    })), isAuthenticated && /*#__PURE__*/React.createElement("div", {
      className: "tb-avatar-wrap"
    }, /*#__PURE__*/React.createElement("button", {
      className: "tb-avatar",
      title: "Profile",
      onClick: () => this.setState({
        profileOpen: !this.state.profileOpen
      })
    }, initials), this.state.profileOpen && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "tb-avatar-backdrop",
      onClick: () => this.setState({
        profileOpen: false
      })
    }), /*#__PURE__*/React.createElement("div", {
      className: "user-profile-pop tb-profile-pop"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Email"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, email)), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Workspace"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, acct.company || acct.account || acct.tenantId || '—')), /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Tenant"), /*#__PURE__*/React.createElement("span", {
      className: "v mono"
    }, acct.tenantId || '—')), (acct.groups || []).length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("span", {
      className: "k"
    }, "Roles"), /*#__PURE__*/React.createElement("span", {
      className: "v"
    }, (acct.groups || []).join(', '))), /*#__PURE__*/React.createElement("div", {
      className: "pop-actions"
    }, isOwner && /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      href: accountUrl(),
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "receipt_long"), " Billing & Usage"), isOwner && /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      href: accountUrl('members'),
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "group"), " Members"), (acct.apps || []).indexOf('studio') !== -1 && /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      href: studioUrl
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "palette"), " Open Plunk Studio"), this.state.managePlanHref && /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      href: this.state.managePlanHref,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "credit_card"), " Manage plan"), /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      href: DOCS + '/commerce/',
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "menu_book"), " Help & docs"), /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      onClick: () => {
        this.setState({
          profileOpen: false
        });
        this.props.history.push('/Settings');
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "settings"), " Settings"), /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      onClick: () => {
        this.setState({
          profileOpen: false
        });
        this.props.history.push('/Privacy');
      }
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "policy"), " Privacy"), /*#__PURE__*/React.createElement("a", {
      className: "pop-link",
      href: "/Auth/SignOut"
    }, /*#__PURE__*/React.createElement("i", {
      className: "material-icons"
    }, "logout"), " Sign Out")))))));
  }
}